import { DropdownItemModel } from 'ng-voxloud';
import { OnboardingLinkAddon } from 'voxloud-types/dist/models';

export interface ActivateFormValue {
  name: string;
  country: { iso2: string };
  deal_id: string;
  expires: { unit: string; value: number; };
  sms: boolean;
  wifi: string;
  paymentMethod: string;
  discount: boolean;
  amount: number; 
  duration: number;
  durationForever: boolean;
  plans: DropdownItemModel[];
}

export interface ExtendedOnboardingLinkAddon extends OnboardingLinkAddon {
  name: string;
  max?: number;
  min: number;
}

export interface SetupFee {
  id: string;
  amount: number;
  name?: string;
  currency?: string;
  isEditable?: boolean;
}

export enum SetupFeeInternalId {
  Accelerator = 'accellerator',
  Priority = 'priority',
  None = 'none'
}